import { getPBI, postPBI } from "../../../services/request"

export const getPowerBIToken = () => {
    return postPBI({
        url: window.configuration.RADPARTNER_FLOWURL,
        headers: { "Accept": "application/json" }
    })
}

export const getEmbedResponse = ({ token, reportId }) => {
    return getPBI({
        url: `${window.configuration.POWER_BI_GROUP_URL}/${window.configuration.RADPARTNER_WORKSPACEID}/reports/${reportId}`,
        token,
    })
}

export const getTokenResponse = ({ token, reportId }) => {
    return postPBI({
        url: `${window.configuration.POWER_BI_GROUP_URL}/${window.configuration.RADPARTNER_WORKSPACEID}/reports/${reportId}/GenerateToken`,
        token,
        body: JSON.stringify({ accessLevel: "View" })
    })
}